import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Session } from './utils/session';
import { API_BASE_URL } from '../config';

export default function Sidebar() {
  const navigate = useNavigate();

  const role = Session.getRole();
  const isSuperAdmin = role === "Super Admin";
  const isAdmin = role === "Admin";
  const isTeamLeader = role === "Team Leader";

  const handleLogout = async  () => {
  try {

    const token = Session.getToken();
    const userId = Session.getUserId();

    await fetch(`${API_BASE_URL}/api/Auth/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        userId: userId
      })
    });

  } catch (error) {
    console.error("Logout Error:", error);
  }
  finally 
  {
    Session.clear();
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/login");
  }
 };

  return (
    <nav id="sidebar">
      <div className="content-box position-relative z-2">
        <span className='logo_text_monitoing'>
          <img src="/images/MD.png" className="imgFluid_logo" alt="Logo" />
          {/* <h3 className="sidebar-title">Monitoring</h3> */}
        </span>
      </div>
      {(isSuperAdmin || isAdmin) && (
        <>
          <p className="sidebar-group-title">Analyze</p>
          <ul className="components">
            <li>
              <NavLink to="/dashboard">
                <i className="fa-solid fa-border-all" /> Dashboard
              </NavLink>
            </li>
            {/* <li>
              <NavLink to="/excelview">
                <i className="fa-solid fa-circle text-danger" style={{ fontSize: 10 }} /> Live Feed
              </NavLink>
            </li> */}
          </ul>
        </>
      )}

      {(isSuperAdmin || isAdmin || isTeamLeader) && (
        <>
          {/* <p className="sidebar-group-title">Analyze</p> */}
          <ul className="components">
            <li>
              <NavLink to="/googlesheet">
                <i className="fa-brands fa-google" style={{ fontSize: 10 }} /> Google Sheet
              </NavLink>
            </li>
          </ul>
        </>
      )}
      <p className="sidebar-group-title">Manage</p>
      <ul className="components">
        <li>
          <NavLink to="/dailytask">
            <i className="fa-solid fa-list-check" /> Task
          </NavLink>
        </li>
      </ul>

      {(isSuperAdmin || isAdmin || isTeamLeader) && (
        <>
          <p className="sidebar-group-title">Admin</p>
          <ul className="components">
            {(isSuperAdmin || isAdmin) && (
              <li>
                <NavLink to="/teams">
                  <i className="fa-solid fa-users" /> Teams
                </NavLink>
              </li>
            )}
            {(isSuperAdmin || isAdmin || isTeamLeader) && (
              <li>
                <NavLink to="/members">
                  <i className="fa-regular fa-user" /> Members
                </NavLink>
              </li>
            )}
             {isSuperAdmin && (
        <li>
          <NavLink to="/Notifications">
            <i className="fa-solid fa-bell" /> Notifications
          </NavLink>
        </li>
        
      )}
          </ul>
        </>
      )}

 {(isSuperAdmin || isAdmin || isTeamLeader) && (
  <>
    <p className="sidebar-group-title">Reports</p>
    <ul className="components">
      <li>
        <NavLink to="/usertimereport" >
          <i className="fa-solid fa-clock" /> User Time Report
        </NavLink>
      </li>
      {/* <li>
        <NavLink to="/tasktimereport" >
          <i className="fa-solid fa-list-check" /> Task Time Report
        </NavLink>
      </li> */}
    </ul>
  </>
)}
      <ul className="components">
        <li onClick={handleLogout}>
          <NavLink to="/">
            <i className="fa-solid fa-right-from-bracket" /> LogOut
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
